import React from 'react'
import { Redirect } from 'react-router-dom'

class VoucherBusinessRedirect extends React.PureComponent {
  render() {
    if (this.props.location && this.props.location.search) {
      const search = this.props.location.search.replace('?business=', '')
      return <Redirect to={{ pathname: `/vouchers`, state: {business: search} }} />
    } else {
      return ''
    }
  }
}

export default VoucherBusinessRedirect



// WEBPACK FOOTER //
// ./src/js/components/VoucherBusinessRedirect.js